import { c as _c } from "react/compiler-runtime";
import { useCarePlanContext } from "../care-plan";
import { CarePlanStep, CarePlanStepStatus, isPatientStep } from "../types";
import { ReactNode, useMemo } from "react";
import { Branch } from "./branch";
import { BranchDisplay } from "./branch-display";
import { BranchLabel } from "./branch-label";
import { BranchStepList } from "./branch-step-list";
import { DecisionStepContext } from "./decision-step-context";
interface DecisionStepRootProps {
  step: CarePlanStep;
  children: ReactNode;
}
function DecisionStepRoot(t0) {
  const $ = _c(26);
  const {
    step,
    children
  } = t0;
  const {
    actions: t1
  } = useCarePlanContext();
  const {
    selectBranch,
    addBranch
  } = t1;
  let t2;
  if ($[0] !== step.branches) {
    t2 = [...(step.branches ?? [])].sort(_temp);
    $[0] = step.branches;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const branches = t2;
  let t3;
  if ($[2] !== branches) {
    t3 = branches.find(_temp2);
    $[2] = branches;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const selectedBranch = t3;
  let t4;
  if ($[4] !== step) {
    t4 = isPatientStep(step) && step.status === CarePlanStepStatus.COMPLETED;
    $[4] = step;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const isResolved = t4;
  const t5 = selectedBranch?.id ?? null;
  let t6;
  if ($[6] !== branches || $[7] !== isResolved || $[8] !== step || $[9] !== t5) {
    t6 = {
      decisionStep: step,
      branches,
      selectedBranchId: t5,
      isResolved
    };
    $[6] = branches;
    $[7] = isResolved;
    $[8] = step;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== selectBranch || $[12] !== step.id) {
    t7 = selectBranch ? branchId => selectBranch(step.id, branchId) : undefined;
    $[11] = selectBranch;
    $[12] = step.id;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== addBranch || $[15] !== step.id) {
    t8 = () => addBranch(step.id);
    $[14] = addBranch;
    $[15] = step.id;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = {
      selectBranch: t7,
      addBranch: t8
    };
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t6 || $[21] !== t9) {
    t10 = {
      state: t6,
      actions: t9
    };
    $[20] = t6;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const value = t10;
  let t11;
  if ($[23] !== children || $[24] !== value) {
    t11 = <DecisionStepContext.Provider value={value}>{children}</DecisionStepContext.Provider>;
    $[23] = children;
    $[24] = value;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}
function _temp2(b_0) {
  return !!b_0.selectedDate;
}
function _temp(a, b) {
  return a.position - b.position;
}
export const DecisionStep = {
  Root: DecisionStepRoot,
  BranchDisplay,
  Branch,
  BranchLabel,
  BranchStepList
};